import axios from 'axios';
import buildPaginationQueryOpts from '@/shared/sort/sorts';
import { IReceivedAnswer } from '@/shared/model/resolution/receivedAnswer.model';
import { ITask } from '@/shared/model/resolution/task.model';
import { ITaskReceived } from '@/shared/model/resolution/taskReceived.model';

const baseApiUrl = 'api/received-answers';

export default class ReceivedAnswerService {
  public find(id: number): Promise<IReceivedAnswer> {
    return new Promise<IReceivedAnswer>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrievePaging(paginationQuery: any, filter: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseApiUrl + `/paging?${buildPaginationQueryOpts(paginationQuery)}`, filter)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IReceivedAnswer): Promise<IReceivedAnswer> {
    return new Promise<IReceivedAnswer>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public createWithFiles(entity: IReceivedAnswer): Promise<IReceivedAnswer> {
    return new Promise<IReceivedAnswer>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/with-files`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IReceivedAnswer): Promise<IReceivedAnswer> {
    return new Promise<IReceivedAnswer>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public updateAnswerResultMessage(entity: IReceivedAnswer): Promise<IReceivedAnswer> {
    return new Promise<IReceivedAnswer>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/update/result-message`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public updateMainFile(answerId: Number, newHashId: String): Promise<any> {
    return new Promise<IReceivedAnswer>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/update-main-file/${answerId}/${newHashId}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public updateWidthFiles(entity: IReceivedAnswer): Promise<IReceivedAnswer> {
    return new Promise<IReceivedAnswer>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/width-files`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveAllList(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `/all-list`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findAllStatusList(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `/status/list`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveTakeControlPaging(paginationQuery: any, filter: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseApiUrl + `/take-control/paging?${buildPaginationQueryOpts(paginationQuery)}`, filter)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveManageTakeControlPaging(paginationQuery: any, filter: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseApiUrl + `/take-control/manage/paging?${buildPaginationQueryOpts(paginationQuery)}`, filter)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveControlAppealAnswerPaging(paginationQuery: any, filter: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseApiUrl + `/control-appeal-answer/manage/paging?${buildPaginationQueryOpts(paginationQuery)}`, filter)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveControlInternalAnswerPaging(paginationQuery: any, filter: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseApiUrl + `/control-internal-answer/paging?${buildPaginationQueryOpts(paginationQuery)}`, filter)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findOneCardInfo(id: number, resolutionId: number): Promise<any> {
    return new Promise<ITask>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/answer-card-info/${id}/${resolutionId}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findOneCopy(id: number): Promise<any> {
    return new Promise<ITask>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/copy/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public saveApprove(entity: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/approve`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public updateStatus(id, status): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/update-status/${id}/${status}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public createTaskReceivedAnswer(entity: ITaskReceived): Promise<ITaskReceived> {
    return new Promise<ITaskReceived>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/add-task-received`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findAllInTask(taskReceivedAnswerId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `/all-answer-list-in-task/${taskReceivedAnswerId}`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findAllListByTaskId(taskId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `/list/by-task/${taskId}`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
